import React from 'react';
import ReactDOM from 'react-dom';

export default class CustomCss extends React.Component {
	constructor(props) {
		super(props);

		this.onLoad = this.onLoad.bind(this);
		this.onSlow = this.onSlow.bind(this);
	}

	componentDidMount() {
		if (this.props.onSlow) {
			this.slowTimeout = setTimeout(this.onSlow, 5000);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.url !== this.props.url && this.props.onSlow) {
			clearTimeout(this.slowTimeout);
			this.slowTimeout = setTimeout(this.onSlow, 5000);
		}
	}

	componentWillUnmount() {
		clearTimeout(this.slowTimeout);
	}

	onSlow() {
		this.props.onSlow && this.props.onSlow(this.props.url);
	}

	onLoad() {
		clearTimeout(this.slowTimeout);
		this.props.onLoad && this.props.onLoad(this.props.url);
	}

	render() {
		const {url, elementId} = this.props;

		if (!url || !elementId) {
			return undefined;
		}

		const element = document.getElementById(elementId);

		if (!element) {
			return undefined;
		}

		return ReactDOM.createPortal(<link href={url} onLoad={this.onLoad} type="text/css" rel="stylesheet"/>, element);
	}
}
